import { createContext } from 'react';
//////////////////////////////////////////////////

const GroupableTableContext = createContext();

GroupableTableContext.displayName = 'GroupableTableContext';

export default GroupableTableContext;
